<template>
  <div class="content">
    <div class="Tabs">

      <b-tabs card v-model="tabIndex">
        <b-tab :title="lang.tab_Details" :title-link-class="textColors" :title-item-class="textColors"
          :active="tabIndex == 0">

          <span v-if="distributorPartId!=undefined">
            <SearchedDetailsPropTableComponent :lang="lang.PropertiesDetails"></SearchedDetailsPropTableComponent>
            <SearchedDetailsAvailabilityTableComponent :lang="lang.AvailabilityDetails" place="search">
            </SearchedDetailsAvailabilityTableComponent>
            <SearchedDetailsPriceTableComponent :lang="lang.PriceDetails"></SearchedDetailsPriceTableComponent>

            <div>

              <b-card class="card" :bg-variant="cardColorsBg" :text-variant="cardColorsText" :title="lang.label_Manual">
                <b-card-text>

                  <label for="endoflife-datepicker" class="param-label">{{ lang.label_EndOfLife }}</label>
                  <b-form-datepicker
                    :disabled="currentUser.role == 'Reader'"
                    id="endoflife-datepicker"
                    v-model="endoflife"
                    :state="endoflifeState"
                    size="sm"
                    class="mb-1 params"
                    today-button
                    reset-button
                    close-button
                    ></b-form-datepicker>
                  <label for="endofsale-datepicker" class="param-label">{{ lang.label_EndOfSale }}</label>
                  <b-form-datepicker
                    :disabled="currentUser.role == 'Reader'"
                    id="endofsale-datepicker"
                    v-model="endofsale"
                    :state="endofsaleState"
                    size="sm"
                    class="mb-1 params"
                    today-button
                    reset-button
                    close-button
                  ></b-form-datepicker>


                  <b-form-group :label="lang.label_OverallRisk" label-for="OverallRisk-input"
                      label-class="param-label-select" class="param-group-select">
                    <b-form-select
                      :disabled="currentUser.role == 'Reader'"
                      class="params select-param form-control"
                      id="OverallRisk_input"
                      v-model="OverallRisk"
                      :options="optionsList"
                      size="sm"
                    ></b-form-select>
                  </b-form-group>


                  <b-form-group :label="lang.label_LifeCycleRiskGrade" label-for="LifeCycleRiskGrade_input"
                      label-class="param-label-select" class="param-group-select">
                    <b-form-select
                      :disabled="currentUser.role == 'Reader'"
                      class="params select-param form-control"
                      id="LifeCycleRiskGrade_input"
                      v-model="LifeCycleRiskGrade"
                      :options="optionsList"
                      size="sm"
                    ></b-form-select>
                  </b-form-group>

                  <b-form-group :label="lang.label_RohsRisk" label-for="RohsRisk_input"
                      label-class="param-label-select" class="param-group-select">
                    <b-form-select
                      :disabled="currentUser.role == 'Reader'"
                      class="params select-param form-control"
                      id="RohsRisk_input"
                      v-model="RohsRisk"
                      :options="optionsList"
                      size="sm"
                    ></b-form-select>
                  </b-form-group>

                  <label for="RoHSVersion-input" class="param-label">{{ lang.label_RoHSVersion}}</label>
                  <b-input v-model="RoHSVersion" class="params" :disabled="currentUser.role == 'Reader'"></b-input>

                  <label for="ChinaRoHSStatus-input" class="param-label">{{ lang.label_ChinaRoHSStatus}}</label>
                  <b-input v-model="ChinaRoHSStatus" class="params" :disabled="currentUser.role == 'Reader'"></b-input>


                  <b-form-group :label="lang.label_LifecycleRisk" label-for="LifecycleRisk_input"
                      label-class="param-label-select" class="param-group-select">
                    <b-form-select
                      :disabled="currentUser.role == 'Reader'"
                      class="params select-param form-control"
                      id="LifecycleRisk_input"
                      v-model="LifecycleRisk"
                      :options="optionsList"
                      size="sm"
                    ></b-form-select>
                  </b-form-group>

                  <label for="PartStatus-input" class="param-label">{{ lang.label_PartStatus}}</label>
                  <b-input v-model="PartStatus" class="params" :disabled="currentUser.role == 'Reader'"></b-input>

                  <label for="EstimatedYearsToEOL-input" class="param-label">{{ lang.label_EstimatedYearsToEOL}}</label>
                  <b-input v-model="EstimatedYearsToEOL" class="params" :disabled="currentUser.role == 'Reader'"></b-input>

                  <b-form-group :label="lang.label_MultiSourcingRisk" label-for="MultiSourcingRisk_input"
                      label-class="param-label-select" class="param-group-select">
                    <b-form-select
                      :disabled="currentUser.role == 'Reader'"
                      class="params select-param form-control"
                      id="MultiSourcingRisk_input"
                      v-model="MultiSourcingRisk"
                      :options="optionsList"
                      size="sm"
                    ></b-form-select>
                  </b-form-group>


                  <label for="comment-textarea" class="param-label">{{ lang.label_Comment }}</label>
                  <b-form-textarea id="comment-textarea" class="item-form comment-textarea mb-1" :rows="6" v-model="comment"
                    :disabled="currentUser.role == 'Reader'" size="sm">
                  </b-form-textarea>
                  <b-button v-if="currentUser.role != 'Reader'" @click="endofpart" :variant="variant" size="sm"
                    class="btn button-update">{{ lang.button_Update }}
                  </b-button>
                </b-card-text>


              </b-card>

            </div>
            <div v-if="globalSettings.SEDetails">

              <SearchedSEDetailsTableComponent :lang="lang.SEDetails" :distributorPartId="distributorPartId" parent="partSearched">
              </SearchedSEDetailsTableComponent>

            </div>
          </span>
          <span v-else>
            {{lang.infotext_1}}
          </span>


        </b-tab>
        <b-tab v-if="currentUser.role != 'Reader'" :title="lang.tab_Search" :title-link-class="textColors"
          :title-item-class="textColors" :active="tabIndex == 1">

          <SearchComponent :lang="lang.Search" parent="PartSearch"></SearchComponent>

        </b-tab>

        <b-tab :title="lang.tab_SelectedPart" :title-link-class="textColors" :title-item-class="textColors"
          :active="tabIndex == 2">
          <p v-if="!isSelectedPart">{{lang.infotext_2}}</p>
          <QuickViewTableComponent v-if="isSelectedPart" :lang="lang.QuickView" parent="Search">
          </QuickViewTableComponent>

        </b-tab>
        <b-tab :title="lang.tab_WhereUsedPhysicals" :title-link-class="textColors" :title-item-class="textColors" :active="tabIndex == 3">

          <WhereUsedPhysicalsComponent :lang="lang.WhereUsedPhysicals"></WhereUsedPhysicalsComponent>

        </b-tab>
      </b-tabs>

    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import SearchComponent from '@/components/shared/SearchComponent'
import SearchedDetailsPropTableComponent from '@/components/shared/SearchedDetailsPropTableComponent'
import SearchedDetailsPriceTableComponent from '@/components/shared/SearchedDetailsPriceTableComponent'
import SearchedDetailsAvailabilityTableComponent from '@/components/shared/SearchedDetailsAvailabilityTableComponent'
import QuickViewTableComponent from '@/components/shared/QuickViewTableComponent'
import WhereUsedPhysicalsComponent from '@/components/shared/WhereUsedPhysicalsComponent'
import SearchedSEDetailsTableComponent from '@/components/shared/SearchedSEDetailsTableComponent'

//import TasksTableComponent from '@/components/shared/TasksTableComponent'

export default {
  name: "Content",
  components: {

    SearchComponent,
    SearchedDetailsPropTableComponent,
    SearchedDetailsPriceTableComponent,
    SearchedDetailsAvailabilityTableComponent,
    QuickViewTableComponent,
    WhereUsedPhysicalsComponent,
    SearchedSEDetailsTableComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      tabIndex: 0,
      endoflife: null,
      endofsale: null,
      comment: "",
      OverallRisk: "",
      LifeCycleRiskGrade: "",
      RohsRisk: "",
      RoHSVersion: "",
      ChinaRoHSStatus: "",
      LifecycleRisk: "",
      PartStatus: "",
      EstimatedYearsToEOL: "",
      MultiSourcingRisk: "",
      endoflifeState: null,
      endofsaleState: null,
      optionsList: [
          { value: null, text: "" },
          { value: "Low", text: "Low" },
          { value: "Medium", text: "Medium" },
          { value: "High", text: "High" },

      ],
    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',
      globalSettings: "globalSettings",
      currentUser: 'currentUser'
    }),
    isSelectedPart(){
      return this.selectedRows.length != 0;
    },
    distributorPartId(){

      return this.$store.getters.selectedSearchedRows.DistributorPartId;

    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }

    },
    cardColorsBg() {
      if (this.$store.getters.s_skinVariant == "dark") {
          return "dark";
      } else {
          return "secondary";
      }

    },
    cardColorsText() {
      if (this.$store.getters.s_skinVariant == "dark") {
          return "white";
      } else {
          return "dark"
      }

    },
  },
  created () {
    this.getTabIndex();


  },
  watch: {
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__right"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################
    },
    distributorPartId: function () {
      this.getPhysicalParam();
    }
  },
  methods: {
    getTabIndex() {


      if (this.$store.getters.tabData[this.$route.path + "__right"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__right"];
      } else {
        this.tabIndex = 0;
      }

    },
    getPhysicalParam() {

      let vue = this;

      const obj = {
        distributorPartId: this.distributorPartId
      }

      this.$store.dispatch("getPhysicalParam", obj)
        .then((result) => {
          console.log(result.data)

          if (result.data.length > 0){

            vue.endoflife = result.data[0].endOfLife;
            vue.endofsale = result.data[0].endOfSale;
            vue.comment = result.data[0].comment;
            vue.OverallRisk = result.data[0].overallRisk;
            vue.LifeCycleRiskGrade = result.data[0].lifeCycleRiskGrade;
            vue.RohsRisk = result.data[0].rohsRisk;
            vue.RoHSVersion = result.data[0].roHSVersion;
            vue.ChinaRoHSStatus = result.data[0].chinaRoHSStatus;
            vue.LifecycleRisk = result.data[0].lifecycleRisk;
            vue.PartStatus = result.data[0].partStatus;
            vue.EstimatedYearsToEOL = result.data[0].estimatedYearsToEOL;
            vue.MultiSourcingRisk = result.data[0].multiSourcingRisk;
          }else{

            vue.endoflife = "";
            vue.endofsale = "";
            vue.comment = "";
            vue.OverallRisk = "";
            vue.LifeCycleRiskGrade = "";
            vue.RohsRisk = "";
            vue.RoHSVersion = "";
            vue.ChinaRoHSStatus = "";
            vue.LifecycleRisk = "";
            vue.PartStatus = "";
            vue.EstimatedYearsToEOL = "";
            vue.MultiSourcingRisk = "";

            if (vue.$route.path == "/PartManager/PartSearch"){



              const obj = {
                distributorPartId: vue.distributorPartId
              }

              vue.$store.dispatch("getPhysicalDetailsAdditional", obj)
              .then((result) => {
                console.log(result.data)


                if (result.data.AdditionalData.length > 0){

                  vue.endoflife = result.data.AdditionalData[0].EOL;
                  vue.endofsale = result.data.AdditionalData[0].EOS;
                  vue.comment = result.data.AdditionalData[0].Comment;
                  vue.OverallRisk = result.data.AdditionalData[0].OverallRisk;
                  vue.LifeCycleRiskGrade = result.data.AdditionalData[0].LifeCycleRiskGrade;
                  vue.RohsRisk = result.data.AdditionalData[0].RohsRisk;
                  vue.RoHSVersion = result.data.AdditionalData[0].RoHSVersion;
                  vue.ChinaRoHSStatus = result.data.AdditionalData[0].ChinaRoHSStatus;
                  vue.LifecycleRisk = result.data.AdditionalData[0].LifecycleRisk;
                  vue.PartStatus = result.data.AdditionalData[0].PartStatus;
                  vue.EstimatedYearsToEOL = result.data.AdditionalData[0].EstimatedYearsToEOL;
                  vue.MultiSourcingRisk = result.data.AdditionalData[0].MultiSourcingRisk;
                }

              })
            }


          }

          vue.checkDateEndOfParts();


        })
    },
    endofpart() {

      let _vue = this;

      const obj = {
        distributorPartId: this.distributorPartId,
        params: {
          endOfLife: this.endoflife,
          endOfSale: this.endofsale,
          comment: this.comment,
          OverallRisk: this.OverallRisk,
          LifeCycleRiskGrade: this.LifeCycleRiskGrade,
          RohsRisk: this.RohsRisk,
          RoHSVersion: this.RoHSVersion,
          ChinaRoHSStatus: this.ChinaRoHSStatus,
          LifecycleRisk: this.LifecycleRisk,
          PartStatus: this.PartStatus,
          EstimatedYearsToEOL: this.EstimatedYearsToEOL,
          MultiSourcingRisk: this.MultiSourcingRisk,
        }

      }

      this.$store.dispatch("pm_updatePhysicalParam", obj)
        .then((result) => {

          if (result.data == 1) {

            _vue.checkDateEndOfParts();

            const obj = {
              text: _vue.lang.alert_success_updateAlternative,
              time: 5,
              type: "success"
            }

            _vue.$store.dispatch("displayFooterAlert", obj);
          } else {

            const obj = {
              text: _vue.lang.alert_error_updateAlternative,
              time: 15,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj);
          }

        })


    },
    checkDateEndOfParts() {

      const now = new Date();
      const oneDay = 1000 * 60 * 60 * 24;



      if (this.endoflife != null) {
        const endoflifeDate = new Date(this.endoflife)
        const diffInTimeA = endoflifeDate.getTime() - now.getTime();
        const diffInDaysA = Math.round(diffInTimeA / oneDay);

        if (diffInDaysA < 365) {
          this.endoflifeState = false;
        } else {
          this.endoflifeState = true;
        }
      } else {
        this.endoflifeState = null;
      }

      if (this.endofsale != null) {

        const endofsaleDate = new Date(this.endofsale)
        const diffInTimeB = endofsaleDate.getTime() - now.getTime();
        const diffInDaysB = Math.round(diffInTimeB / oneDay);

        if (diffInDaysB < 365) {
          this.endofsaleState = false;
        } else {
          this.endofsaleState = true;
        }
      } else {
        this.endofsaleState = null;
      }
    },
  }
}
</script>

<style lang="scss">

  .Tabs{

    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }
    .comment-textarea {
      height: 90px;
    }
    .params{
        max-width: 300px;
    }
    .param-label{
      margin-top: 0.5rem;
      margin-bottom: 0.1rem;
    }
    .param-label-select{
      margin-top: 0.5rem;
      margin-bottom: 0.1rem;
    }
    .param-group-select{
      margin-bottom: 0.1rem;

    }
    .select-param{
      border-color: #666;
    }
    .card-title{
      font-size: 1rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartSearch/Right/Content/Content.vue